<template>
  <d-alert
    v-model="isAlertOpen"
    :index="alertConfig.index"
    :type="alertConfig.type"
    :manualClose="alertConfig.manualClose"
    :message="alertConfig.message"
    :upper="alertConfig.upper"
  />
</template>

<script>
import { mapActions, mapState } from "vuex";
import DAlert from "@/components/ui_components/DAlert.vue";

export default {
  name: "DGlobalAlert",
  components: {
    DAlert,
  },
  watch: {
    // sync v-model is close  will triger vuex change to close
    isAlertOpen: {
      immediate: true,
      handler(isAlertOpen) {
        if (!isAlertOpen && this.alertConfig.isOpen) {
          this.closeAlert();
        }
      },
    },
    // sync vuex is open  will triger v-model change to open
    "alertConfig.isOpen": {
      immediate: true,
      handler(isOpen) {
        if (isOpen && !this.isAlertOpen) {
          this.isAlertOpen = true;
        }
      },
    },
  },
  data: function () {
    return {
      isAlertOpen: false,
    };
  },
  methods: {
    ...mapActions("global", ["closeAlert"]),
  },
  computed: {
    ...mapState("global", ["alertConfig"]),
  },
};
</script>
